import React from 'react';
import { Modal, UnstyledButton } from '@mantine/core';
import type { PrinterView } from '../../../../services/printers/printers.service';
import classes from './pos-report-modal.module.scss';

export type ReportPrinterPickModalProps = {
  opened: boolean;
  printers: PrinterView[];
  disabled?: boolean;
  onConfirm: (printerId: number) => void;
  onClose: () => void;
};

// Summary: Z/X-report select-then-confirm printer picker as a reusable modal.
const ReportPrinterPickModalComponent: React.FC<ReportPrinterPickModalProps> = ({
  opened,
  printers,
  disabled = false,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={() => { if (!disabled) onClose(); }}
      title={<strong className={classes.pickerModalTitle}>בחר מדפסת</strong>}
      centered
      radius="md"
      dir="rtl"
      zIndex={1200}
      closeButtonProps={{ 'data-testid': 'report-printer-pick-close' } as Record<string, string>}
      classNames={{ header: classes.pickerModalHeader, title: classes.pickerModalTitle }}
    >
      <div className={classes.pickerStack}>
        {printers.length === 0 ? (
          <span className={classes.pickerEmpty}>אין מדפסות פעילות</span>
        ) : (
          <div className={classes.pickerList}>
            {printers.map((printer) => {
              return (
                <UnstyledButton
                  key={printer.id}
                  component="button"
                  type="button"
                  data-testid={`report-printer-pick-option-${printer.id}`}
                  className={classes.pickerItem}
                  onClick={() => onConfirm(printer.id)}
                  disabled={disabled}
                >
                  <span>{printer.name}</span>
                </UnstyledButton>
              );
            })}
          </div>
        )}
      </div>
    </Modal>
  );
};

export const ReportPrinterPickModal = React.memo(ReportPrinterPickModalComponent);
